
  // Export
  module.exports =
  {

    // Controller-wide scripts
    _init: function ()
    {

      // On selecting a date
      $('.date-select').not('.js-ignore').click(function ()
      {
  
        // Run the datepicker
        APPLICATION._datepicker($(this).attr('data-' + APPLICATION._DATA_PREFIX + 'date'))
  
        // Remove the date picker
        APPLICATION._datepicker = null
  
      }
      ).addClass('js-ignore')

    },

    // Modal
    _modal: function (input, type, query_string)
    {

      // Store the datepicker
      APPLICATION._datepicker = function (date)
      {

        // Set the from date
        input.val(date).trigger('change')

        // Close the datpicker
        $('body').removeClass('show-modal')

      }

      // Get the parts
      var parts = input.val().split('/')

      // Show the custom modal
      APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'calendar/' + type + '/' + parts[2] + '/' + parts[1] + '?date=' + parts[2] + '-' + parts[1] + '-' + parts[0] + '&' + query_string, 'Calendar', type)

    }

  }